<!-- 供货商 -->
<template>
    <div class='page_content'>
        <!-- <supplierCommonAction ref="supplierCommonAction"></supplierCommonAction> -->
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <supplierCommonAction v-if="showStatus" ref="supplierCommonAction" @drawerCancel="drawerCancel" :actionData="actionData"></supplierCommonAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
            </div>
        </div>

        <div class="page_content_center">
            <div class="left" :style="{height: tableHeight+'px'}" v-if="isMenu">
                <el-menu :default-active="activeMenu" :key="'menu-' + menuList.length" class="el-menu-vertical-demo" @select="handleMenuSelect">
                    <el-menu-item index="all">
                        <i class="el-icon-menu"></i>
                        <span slot="title">全部</span>
                    </el-menu-item>
                    <el-menu-item v-for="item in menuList" :key="item.codeId" :index="String(item.codeId)">
                        <i class="el-icon-document"></i>
                        <span slot="title">{{ item.codeType }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="right" :class="{ 'right-full': !isMenu }">
                <el-table v-if="pageShowData.jurTableVo" @sort-change="sortChange" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row
                          size="mini">
                    <el-table-column label="选择操作" align="center" width="80">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <!-- 主表单 -->
                    <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                        <el-table-column v-if="tableValye.isShow == 1" align="center" :sortable="tableValye.isSort == 1?'custom':false" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField"
                                         show-overflow-tooltip :min-width="tableValye.fieldWeight">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                            }}</a>
                                </span>
                                <span v-else-if="tableValye.fieldType == 'formatter'">
                                    <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                        <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">{{ item.value }}</el-tag>
                                    </span>
                                </span>
                                <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog v-if="statusFlag" title="修改状态" :visible.sync="statusFlag" append-to-body top="20%" width="600px">
            <el-form @submit.native.prevent size="mini" :model="statusSendData" ref="statusSendData" label-width="100px">
                <el-form-item label="状态" prop="smState" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-select v-model="statusSendData.smState" size="mini" clearable>
                        <el-option label="停用" :value="0"></el-option>
                        <el-option label="正常" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="smRemark">
                    <el-input v-model.trim="statusSendData.smRemark" type="textarea" size="mini" clearable :maxlength="$store.state.inputLength"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="statusFlag = false">取 消</el-button>
                <el-button type="primary" v-if="actionDataActionType == 17" @click="setStatusDataAction1('statusSendData')">确 定</el-button>
                <el-button type="primary" v-else @click="setStatusDataAction('statusSendData')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import supplierCommonAction from "@/components/supplierCommonAction.vue"
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        supplierCommonAction,
    },
    data() {
        //这里存放数据
        return {
            ormId: "",
            requesUrl: '',
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            selectedDataList: [],
            pageShowData: [],
            formDataList: [],
            imgUrl: '',
            dialogisible: false,
            dialogImageUrl: '',
            selectedDataIndex: 0,
            showStatus: false,
            actionData: [],
            statusFlag: false,
            statusSendData: {
                smId: '', //	供应商ID
                smRemark: '', //	备注
                smState: '', //	供应商状态
            },
            DialogVisible: false,
            parentSearchData: {},
            seTitle: "",
            seWidth: "",
            actionDataActionType: '',
            menuList: [],
            activeMenu: "all",
            isMenu: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        //检索方案
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            console.log(val)
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        handleSortChange({ column, prop, order }) {
            console.log(`排序字段: ${prop}, 排序方向: ${order}`);
            // 根据排序结果对tableData进行排序操作
            this.returnData.list.sort((a, b) => {
                if (order === 'ascending') {
                    return a[prop] > b[prop] ? 1 : -1;
                } else if (order === 'descending') {
                    return a[prop] < b[prop] ? 1 : -1;
                } else {
                    return 0;
                }
            });

        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false
            commitData && this.getDataList()
        },
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.$store.getters.getConfig.imgUrl + item.fileUrl);
            });

            return imgList;
        },
        isShowData(name, value) {
            this.sendDataInfo[name] = value;
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.getButtonList()
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                await this.getMenuData()
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 左侧菜单切换
        handleMenuSelect(codeId) {
            this.activeMenu = String(codeId)
            if (codeId === 'all') {
                this.$set(this.getRequestData, 'codeType', '')
            } else {
                const menuItem = this.menuList.find(item => String(item.codeId) === String(codeId))
                if (!menuItem) return
                this.$set(this.getRequestData, 'codeType', menuItem.codeType)
            }
            this.getRequestData.page = 1
            this.getDataList()
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            var formData = this.formDataList
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: formData,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: '',
                        fatherType: ''
                    }
                    break;
                case 1:
                    var olddataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]));
                    if (!olddataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    let data
                    this.$http.querySupplierInfo({
                        ids: [olddataInfo.smId]
                    }).then(res => {
                        if (res.status == 200) {
                            data = res.result
                            this.showStatus = true;
                            this.actionData = {
                                cate: actionData.actionType,
                                formData: formData,
                                oldData: data,
                                orderId: data.smId,
                                printSouce: '',
                                printJurId: '',
                                fatherType: ''
                            }
                        }
                    })

                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.copyDataAction();
                    break;
                case 4:

                    break;
                case 6:
                    this.exportMainInfo()
                    break;
                case 7:
                    this.exportLicenceInfo()
                    break;
                case 15:
                    this.openFormDesign()
                    break;
                case 16:
                    this.actionDataActionType = actionData.actionType
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.statusSendData.smId = dataInfo['smId']
                    this.statusSendData.smRemark = dataInfo['smRemark'] //	备注
                    this.statusSendData.smState = dataInfo['smState'] //	商品状态

                    this.statusFlag = true;
                    break;
                case 17:
                    this.actionDataActionType = actionData.actionType
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.statusSendData.smId = dataInfo['smId']
                    this.statusSendData.smRemark = dataInfo['smPustateRemark'] //	备注
                    this.statusSendData.smState = dataInfo['smPustate'] //	商品状态

                    this.statusFlag = true;
                    break;
                case 11://维护SPD编码
                    this.maintainSPD()
                    break;
            }
        },
        // 维护SPD编码
        maintainSPD() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];

            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$prompt('请输入SPD编码', '维护SPD编码', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S+/,
                inputErrorMessage: 'SPD编码不能为空'
            }).then(async ({ value }) => {
                const params = {
                    spdCode: value,
                    unitId: dataInfo.smId,
                    type: 1
                }
                const res = await this.$http.supplierupdateSpdCode(params)
                if (res.status == 200) {
                    this.$message.success(res.message)
                    this.getDataList()
                } else {
                    this.$message.error(res.message)
                }
            }).catch(() => { });
        },
        // 导出供应商资料数据
        exportMainInfo() {
            window.location.href = this.requesUrl + `/gspSupplier/exportSupData${this.$common.getUrl(this.getRequestData)}&ormId=${String(this.ormId)}`;
        },
        // 导出供应商证照资料数据
        exportLicenceInfo() {
            window.location.href = this.requesUrl + `/gspSupplier/exportSupLicenceData${this.$common.getUrl(this.getRequestData)}&ormId=${String(this.ormId)}`;
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getSupplier(this.getRequestData);
            if (responseData.status == 200) {
                // this.returnData.list = responseData.result.list;
                this.returnData.list = this.$common.getIndex(responseData.result.list)
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                // this.selectedDataList = [];
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getMenuData() {
            const params = { codeClassify: 1 }
            const res = await this.$http.getQueryCodeClassify(params)
            if (res.status == 200) {
                this.menuList = res.result || []
            } else {
                this.menuList = []
            }
            this.activeMenu = "all"
            this.$set(this.getRequestData, 'codeType', '')
        },

        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.smId],
                    };
                    let responseData = await this.$http.delSupplier(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.selectedDataIndex = 0
                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        sendDataAction(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.modifyStatusGoods(this.statusSendData).then(res => {
                        if (res.status == 200) {
                            this.$refs[formName].resetFields()
                            this.statusFlag = false;
                            this.getDataList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })
        },
        // 更改状态数据
        setStatusDataAction(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.setSupplierStatus(this.statusSendData).then(res => {
                        if (res.status == 200) {
                            this.$refs[formName].resetFields()
                            this.statusFlag = false;
                            this.getDataList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })
        },
        setStatusDataAction1(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.supplierModifyPuState(this.statusSendData).then(res => {
                        if (res.status == 200) {
                            this.$refs[formName].resetFields()
                            this.statusFlag = false;
                            this.getDataList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })
        },
        // 拷贝数据
        copyDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("确定要拷贝吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var senData = {
                        smId: dataInfo.smId,
                    };
                    let responseData = await this.$http.copySupplier(senData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
//结束时间改成最后时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.getRequestData.end = time
            }
        },


    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.ormId = sessionStorage.getItem('ormId')
        this.isMenu = window.global_config.isLeftMenuBgm || false
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.page_content_center {
    display: flex;
    justify-content: space-between;
}

.left {
    flex-shrink: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 150px;
}

.el-menu-vertical-demo {
    width: 150px;
    border-right: none;
}

.right {
    flex: 1;
    min-width: 0;
    width: calc(100% - 160px);
}

.right-full {
    width: 100%;
}

::v-deep .el-menu-item {
    height: 36px;
    line-height: 36px;
}
</style>